import {
    validatorParentescoEmDuplicidade,
    retornaLabelDoValorParentesco,
    idadeAte65,
    idadeAcima65,
    validarLimiteCategoria,
    validarExisteDoisDependAcima65Anos,
    IDADE_ENUM
} from './funcoesAuxiliaresZFL';

export class CorrenteEdicaoZFL {
    constructor(
        dependentes,
        parentesco,
        categorias,
        valoresForm,
        isValid,
        idadeAssociado
    ) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.isValid = isValid;
        this.categoriaSelecionada = valoresForm.Categoria;
        this.qtdDependentes = this.dependentes.length;
        this.idadeAssociado = idadeAssociado;
        this.msgDepEspecial =
            'Para este plano só pode ser inserido um dependente especial';
    }

    verificarMudancaIdade() {
        if (
            this.isValid.Idade !== this.valoresForm.Idade &&
            this.valoresForm.Idade > IDADE_ENUM.sessentaCinco
        ) {
            if (
                validarExisteDoisDependAcima65Anos(
                    this.dependentes,
                    this.valoresForm.Idade,
                    this.idadeAssociado
                )
            ) {
                this.arrayMsgsErro.push(this.msgDepEspecial);
            }
        }

        return this;
    }

    verificarMudancaCategoria() {
        if (this.isValid.Categoria !== this.categoriaSelecionada) {
            return this.validarCategoriasPlano();
        }

        return this;
    }

    validarCategoriasPlano() {
        switch (this.valoresForm.Categoria.trim()) {
        case 'ZELO':
            if (!validarLimiteCategoria(this.dependentes, 'ZELO', 4)) {
                this.arrayMsgsErro.push(
                    'O máximo de dependentes sem valor adicional são quatro dependentes.'
                );
            }

            break;
        case 'ZTA64':
            if (
                !validarLimiteCategoria(this.dependentes, 'ZTA64', 1) &&
                    !this.arrayMsgsErro.includes(this.msgDepEspecial)
            ) {
                this.arrayMsgsErro.push(this.msgDepEspecial);
            }

            break;
        case 'ZTM65':
            if (!validarLimiteCategoria(this.dependentes, 'ZTM65', 1)) {
                this.arrayMsgsErro.push(
                    'Para este plano só pode ser inserido um dependente especial.'
                );
            }

            break;
        }

        return this;
    }

    parentescoEpecialComAdicionalAte65() {
        if (this.valoresForm.Idade && idadeAte65(this.valoresForm.Idade)) {
            if (this.valoresForm.Categoria && this.valoresForm.Categoria === 'ZTM65') {
                this.arrayMsgsErro.push(
                    'A categoria selecionada não corresponde a idade do dependente.'
                );
            }
        }

        return this;
    }

    parentescoEspecialComAdicionalMaior65() {
        if (this.valoresForm.Idade && idadeAcima65(this.valoresForm.Idade)) {
            if (this.valoresForm.Categoria && this.valoresForm.Categoria === 'ZTA64') {
                this.arrayMsgsErro.push(
                    'A categoria selecionada não corresponde a idade do dependente.'
                );
            }
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro = [`${retornaLabelDoValorParentesco(this.parentesco)}`];
        }

        return this;
    }

    validarQtdDependentesAcima65Anos() {
        if (
            validarExisteDoisDependAcima65Anos(
                this.dependentes,
                this.valoresForm.Idade,
                this.idadeAssociado
            )
        ) {
            this.arrayMsgsErro.push(
                'Neste plano só é permitido duas pessoas acima de 64 anos, incluindo o titular.'
            );
        }

        return this;
    }
}
